export default __webpack_public_path__ + "static/grades2024-9e6d5bebf6053a8140ff8fab22e4c6d3.png";